import LocomotiveScroll from "locomotive-scroll"
import "./Header.css"



const Header = () => {
    const scrollTo_A = () => {
    
        const scroll = new LocomotiveScroll();
        
  
        let el = document.getElementById("About")
    
      el?.scrollIntoView();
  
      }
      const scrollTo_C = () => {
    
        const scroll = new LocomotiveScroll();
        
  
        let el = document.getElementById("contacts")
    
      el?.scrollIntoView();
  
      }



    return (
        <div className="header-container" data-scroll-section>
           
       
           <ul className="header-menu">
               <li onClick={()=> scrollTo_A()}>About</li>
               <li onClick={()=> scrollTo_C()}>Contacts</li>

            </ul>
        
        <div>
           <div className="header-descr">
               <h1 id="header-text">Front-end & Mobile App developer</h1>
               <h2>Hi, I am Sfundo</h2>
               <p>I create amazing experiences for all platforms and devices with JavaScript</p>
           </div>


         <div className="call">
                <a href="mailto:mhlungusk@gmail.com">
                
                Contact

            </a>

         </div>
         </div>
    </div>

    )
} 

export default Header